import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrSubformComponent } from './pr-subform.component';
import { PrButtonModule } from '@app/components/pr-button/pr-button/pr-button.module';
import { PrButtonConfirmModule } from '@app/components/pr-button/pr-button-confirmation/pr-button-confirm.module';

@NgModule({
  declarations: [PrSubformComponent],
  imports: [CommonModule, PrButtonModule, PrButtonConfirmModule],
  exports: [PrSubformComponent],
})
export class PrSubformModule {}
